<template>
	<div class="PopAgreement-component">
		<el-dialog class="PopAgreement" append-to-body center :title="details.title" :visible.sync="visible" :lock-scroll="false">
			<slot>
				<div class="PopAgreement-body" >
					<div class="pb-content" v-html="details.content"></div>
				</div>
			</slot>
			<slot slot="footer">
				<el-button class="PopAgreement-footer" type="primary" @click="close">我已知晓</el-button>
			</slot>
		</el-dialog>
	</div>
</template>

<script>
	var details = {
		title: '',
		content: ''
	}
	export default {
		name: 'PopAgreement',
		props: {
			show: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				visible: false,
				details: {
					...details
				},
			}
		},
		watch: {
			show: {
				handler: function(val) {
					this.visible = val
				},
				immediate: true
			},
			visible: {
				handler: function(val) {
					this.$emit('update:show', val)
				}
			},
		},
		methods: {
			open(data={}) {
				this.details = {...details,...data}
				this.visible = true
			},
			close() {
				this.visible = false
			},
			confirm() {
				this.details.confirm()
				this.close()
			},
			
		}
	}
</script>

<style lang="scss">
	// 修改自带样式
	.el-dialog__wrapper.PopAgreement {
		display: flex;
		align-items: flex-start;
		.el-dialog {
			width: auto;
			margin: auto !important;
			// background-color: transparent;
			.el-dialog__header {
				// padding: 0;
			}
			.el-dialog__body {
				padding: 0;
			}
			.el-dialog__footer {
				// padding: 0;
			}
		}
	}
	.PopAgreement-body {
		width: 800px;
		overflow-y: auto;
		min-height: 40vh;
		max-height: 60vh;

		.pb-content {
			box-sizing: border-box;
			padding: 30px 20px;
			font-size: 14px;
			color: #666666;
		}
	}

</style>